<h1 class="accessibility-only">{{ 'challenges.page.title' | translate }}</h1>

<ng-container *ifScreenSize="screenType.Desktop">
  <div class="banner" role="banner"></div>
</ng-container>

<fgb-page-header [pageTitle]="'challenges.page.title'" [backButtonLink]="'/'" [showQr]="sgb ? false : true"></fgb-page-header>

<!--Account Nav-->
<ng-container *ifScreenSize="screenType.Desktop">
  <fgb-account-nav></fgb-account-nav>
</ng-container>

<div class="container badge-achieved-container">
  <fgbcl-badge-achieved></fgbcl-badge-achieved>
</div>

<!--Scorecard carousel-->
<fgbcl-scorecard-list-view
  [isSponsorInBody]="false"
  [icon]="'chevron_right'"
  [showPlaceholder]="true"
></fgbcl-scorecard-list-view>
